import React, { useEffect, useRef, useState } from "react";
import "../../App.css";
import PageTitle from "../../Module/pageTitle";
import { useDispatch, useSelector } from "react-redux";
import {
  getTeacherTaskList,
  getAllTeachersList,
  getParentCourseNew,
  getExamListNew,
} from "../../Action/courseAction";
import AdminTable from "../../Component/adminTable";
import LabelField from "../../Component/labelField";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import moment from "moment";
import DatePicker from "../../Component/datePicker";
import { defaultDuration, taskTypeList } from "../../Utils/dataConstants";
import { holidays } from "../../Utils/dataConstants";
import { DownloadTableExcel } from "react-export-table-to-excel";
import secondsToTimestamp from "seconds-to-timestamp";
import Dropdown from "../../Component/dropdown";
import SubmitButton from "../../Component/SubmitButton";

function TeacherTaskPlan() {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [searchStartDate, setSearchStartDate] = useState(
    moment.utc(moment.utc(new Date())).format("YYYY-MM-DD")
  );
  const [searchEndDate, setSearchEndDate] = useState(
    moment.utc(moment.utc(new Date())).format("YYYY-MM-DD")
  );
  const [searchExam, setSearchExamName] = useState("");
  const [searchExamStream, setSearchExamStream] = useState("");
  const [searchTaskType, setSearchTaskType] = useState({
    _id: 1,
    name: "PAID APP LIVE",
    value: "PAID_APP_LIVE",
  });
  const [searchTeacherName, setSearchTeacherName] = useState("");

  const [totalSundays, setTotalSundays] = useState(0);
  const [totalLeaves, setTotalLeaves] = useState(0);
  const [workingDays, setWorkingDays] = useState(0);
  const [unassignedDays, setUnassignedDays] = useState(0);
  const [calHoliday, setCalHoliday] = useState(0);

  const [examStreamList, setExamStreamList] = useState([]);
  const [examList, setExamList] = useState([]);
  const [teacherList, setTeacherList] = useState([]);
  const [teacherTaskList, setTeacherTaskList] = useState([]);

  const [totalExpectedDuration, setTotalExpectedDuration] =
    useState(defaultDuration);
  const [totalAssignedDuration, setTotalAssignedDuration] =
    useState(defaultDuration);
  const [totalAchievedDuration, setTotalAchievedDuration] =
    useState(defaultDuration);

  const { isEditMode } = useSelector((state) => ({
    isEditMode: state.courseReducer?.isEditMode,
  }));

  const getDays = (start, end) => {
    if (end < start) return;
    for (
      var count = { sun: 0, sat: 0 };
      start <= end;
      start.setDate(start.getDate() + 1)
    ) {
      if (start.getDay() === 0) count.sun++;
      else if (start.getDay() === 6) count.sat++;
    }
    return count;
  };

  function calculateTotalHolidays(searchStartDate, searchEndDate, holidays) {
    const start = searchStartDate.getTime();
    const end = searchEndDate.getTime();
    // Initialize variable to count holidays
    let totalHolidays = 0;
    // Loop through each day between start and end dates
    for (
      let currentDate = start;
      currentDate <= end;
      currentDate += 24 * 60 * 60 * 1000
    ) {
      const formattedDate = new Date(currentDate).toISOString().split("T")[0]; // Format date for comparison
      // Check if the formatted date is in the holidays array
      if (holidays.includes(formattedDate)) {
        totalHolidays++;
      }
    }
    return totalHolidays;
  }

  const setting_data = async (response) => {
    const totalHolidays = calculateTotalHolidays(
      new Date(searchStartDate),
      new Date(searchEndDate),
      holidays
    );

    let taskDuration = 0;
    let workDuration = 0;
    let countLeave = 0;
    let taskDaysSet = new Set();

    if (response?.data?.length > 0) {
      setTeacherTaskList(response?.data);

      response?.data?.forEach((item) => {
        taskDuration += parseFloat(item?.taskDuration) || 0;
        workDuration += parseFloat(item?.workDuration) || 0;
        if (item?.status === 4) countLeave += 1;

        if (item?.taskDate) {
          taskDaysSet.add(moment(item.taskDate).format("YYYY-MM-DD"));
        }
      });

      const taskDaysCount = taskDaysSet.size;

      const startD = moment.utc(searchStartDate);
      const endD = moment.utc(searchEndDate);
      const diffDays = endD.diff(startD, "days") + 1;

      const count = getDays(new Date(searchStartDate), new Date(searchEndDate));
      setTotalSundays(count.sun);

      getTaskDuration(taskDuration);
      getWorkDuration(workDuration);

      setTotalLeaves(response?.totalLeaves || 0);

      const totalMultiplier = 4.5 * (response?.countUniqueTeachersCount || 0);
      const check =
        (diffDays * totalMultiplier -
          ((response?.totalLeaves || 0) * 4.5 +
            count.sun * 4.5 +
            totalHolidays * 4.5)) *
        60;
      getExpectedDuration(check);

      const totalDays = Math.max(0, diffDays - count.sun - totalHolidays);
      const availableTeacherDays =
        totalDays * (response?.countUniqueTeachersCount ?? 0);
      const occupiedDays = (response?.totalLeaves ?? 0) + taskDaysCount;

      const countUnassigned = Math.max(0, availableTeacherDays - occupiedDays);

      setUnassignedDays(countUnassigned);

      const workingDays = Math.max(
        0,
        diffDays * (response?.countUniqueTeachersCount || 0) -
          (count.sun + (response?.totalLeaves || 0) + totalHolidays)
      );
      setWorkingDays(workingDays);

      setCalHoliday(totalHolidays);
    } else {
      setTeacherTaskList(response?.data);
      setTotalSundays(0);
      getExpectedDuration(0);
      getTaskDuration(0);
      getWorkDuration(0);
      setTotalLeaves(response?.totalLeaves);
      setWorkingDays(0);
      setUnassignedDays(0);
      setCalHoliday(0);
    }
  };

  const getExpectedDuration = (value) => {
    let { minutes, hours, seconds, days } = moment.duration(
      value,
      "minutes"
    )._data;
    let tempHours = 0;
    tempHours = hours + days * 24;
    setTotalExpectedDuration(
      `${tempHours < 10 ? "0" + tempHours : tempHours}` +
        ":" +
        `${minutes < 10 ? "0" + minutes : minutes}` +
        ":" +
        `${seconds < 10 ? "0" + seconds : seconds}`
    );
  };

  const getTaskDuration = (value) => {
    let { minutes, hours, seconds, days } = moment.duration(
      value,
      "minutes"
    )._data;
    let tempHours = 0;
    tempHours = hours + days * 24;
    setTotalAssignedDuration(
      `${tempHours < 10 ? "0" + tempHours : tempHours}` +
        ":" +
        `${minutes < 10 ? "0" + minutes : minutes}` +
        ":" +
        `${seconds < 10 ? "0" + seconds : seconds}`
    );
  };

  const getWorkDuration = (value) => {
    let { minutes, hours, seconds, days } = moment.duration(
      value,
      "minutes"
    )._data;
    let tempHours = 0;
    tempHours = hours + days * 24;
    setTotalAchievedDuration(
      `${tempHours < 10 ? "0" + tempHours : tempHours}` +
        ":" +
        `${minutes < 10 ? "0" + minutes : minutes}` +
        ":" +
        `${seconds < 10 ? "0" + seconds : seconds}`
    );
  };

  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        setExamList(res);
      })
    );
    dispatch(
      getAllTeachersList(
        {
          skip: 0,
          limit: 100,
        },
        (res) => {
          setTeacherList(res?.data?.data);
        },
        () => {}
      )
    );
    fetchData();
  }, []);

  const onSearchChangeEndDate = (value) => {
    setSearchEndDate(value);
    setTeacherTaskList([]);
    setTotalExpectedDuration(defaultDuration);
    setTotalAssignedDuration(defaultDuration);
    setTotalAchievedDuration(defaultDuration);
    if (value < searchStartDate) {
      dispatch(showErrorSnackbar("End date must be greater than start date"));
    }
  };

  const onSearchChangeTeacher = (value) => {
    setSearchTeacherName(value);
    setSearchExamName("");
    setSearchExamStream("");
    setExamStreamList([]);
  };

  const onSearchChangeExam = (value) => {
    setSearchExamName(value);
    setSearchExamStream("");
    setExamStreamList([]);
    if (value) {
      dispatch(
        getParentCourseNew(`${value._id}`, (res) => {
          setExamStreamList(res);
        })
      );
    }
  };

  const onSearchChangeExamStream = (value) => {
    setSearchExamStream(value);
  };

  const onSearchChangeTaskType = (value) => {
    setSearchTaskType(value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchData();
  };

  const fetchData = () => {
    if (searchStartDate && searchEndDate) {
      let postData = {
        startDate: searchStartDate,
        endDate: searchEndDate,
      };
      if (searchExam) {
        postData["examTypeId"] = searchExam?._id;
      }
      if (searchExamStream) {
        postData["baseCourseId"] = searchExamStream?._id;
      }
      if (searchTeacherName) {
        postData["teacherId"] = searchTeacherName?._id;
      }
      if (searchTaskType) {
        postData["taskType"] = searchTaskType?.value;
      }
      dispatch(
        getTeacherTaskList(postData, (res) => {
          setting_data(res?.data);
        })
      );
    } else {
      dispatch(showErrorSnackbar("Please Select Start Date & End Date"));
    }
  };

  const getSeconds = (minutes) => {
    let seconds = minutes * 60;
    return secondsToTimestamp(seconds);
  };

  const renderListMode = () => {
    let maxD = moment(searchStartDate).add(1, "months").calendar();
    return (
      <>
        <form className="d-flex" onSubmit={handleSearch}>
          <div className="w-50">
            <div className="d-flex align-items-center px-1">
              <LabelField labelName={"Start Date"} isRequired={true} />
              <DatePicker
                setInputText={(value) => {
                  setSearchStartDate(value);
                }}
                value={searchStartDate}
              />
            </div>
            <div className="d-flex align-items-center px-1">
              <LabelField labelName={"Teacher Name"} />
              <div className="w-100">
                <Dropdown
                  labelName="Select Teacher Name"
                  setInputText={(value) => onSearchChangeTeacher(value)}
                  options={teacherList}
                  value={searchTeacherName}
                />
              </div>
            </div>
            <div className="d-flex align-items-center px-1">
              <LabelField labelName={"Exam Stream"} />
              <div className="w-100">
                <Dropdown
                  labelName="Select Exam Stream"
                  setInputText={(value) => onSearchChangeExamStream(value)}
                  options={examStreamList}
                  value={searchExamStream}
                />
              </div>
            </div>
          </div>
          <div className="w-50">
            <div className="d-flex align-items-center px-1">
              <LabelField labelName={"End Date"} isRequired={true} />
              <DatePicker
                setInputText={(value) => onSearchChangeEndDate(value)}
                value={searchEndDate}
                mindate={searchStartDate}
                maxdate={moment(maxD).format("YYYY-MM-DD")}
              />
            </div>
            <div className="d-flex align-items-center px-1">
              <LabelField labelName={"Exam Name"} />
              <div className="w-100">
                <Dropdown
                  labelName="Select Exam Name"
                  setInputText={(value) => onSearchChangeExam(value)}
                  options={examList}
                  value={searchExam}
                />
              </div>
            </div>

            <div className="d-flex align-items-center px-1">
              <LabelField labelName={"Task Type"} />
              <div className="w-100">
                <Dropdown
                  labelName="Select Task Type"
                  setInputText={(value) => onSearchChangeTaskType(value)}
                  options={taskTypeList}
                  value={searchTaskType}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="d-flex flex-column justify-content-between">
            {teacherTaskList?.length !== 0 ? (
              <div className="d-flex justify-content-end">
                <DownloadTableExcel
                  filename="Teacher Task List"
                  sheet="Teacher Task List"
                  currentTableRef={tableRef.current}
                >
                  <button className="btn btn-outline-primary submitbtn">
                    Export
                  </button>
                </DownloadTableExcel>
              </div>
            ) : null}
            <SubmitButton name="Search" />
          </div>
        </form>
        <div
          className="d-flex justify-content-between p-2"
          style={{ backgroundColor: "#E8EAF5" }}
        >
          <div>
            <div className="me-2">
              <h4>Total Expected Duration: {totalExpectedDuration}</h4>
              {searchTeacherName ? (
                <>
                  <h6>Total No. of Sundays : {totalSundays}</h6>
                  <h6>Total No. of Leaves : {totalLeaves}</h6>
                  <h6>Total Working Days : {workingDays}</h6>
                  <h6>Calendar Holidays : {calHoliday}</h6>
                  <h6>Unassigned Task Days : {unassignedDays}</h6>
                </>
              ) : null}
            </div>
          </div>
          <div className="d-flex">
            <div className="me-2">
              <h4>Total Assigned Duration: {totalAssignedDuration}</h4>
              <h4>Total Achieved Duration: {totalAchievedDuration}</h4>
            </div>
          </div>
        </div>

        <AdminTable
          pagename={"DisplayTeacherTasksPlan"}
          tableHead={[
            "S.N",
            "TASK DATE",
            "TASK TYPE",
            "EXAM NAME",
            "TASK TITLE",
            "TEACHER NAME",
            "EXPECTED START DATE",
            "ACTUAL START DATE",
            "DEFICIT",
            "EXPECTED DURATION",
            "AUDITOR COMMENT",
            "LINK / SCREENSHOT",
            "STATUS",
            "ACHIEVED DURATION",
            "ASSIGNED BY",
            "UPDATED AT",
          ]}
          tableData={teacherTaskList ? teacherTaskList : []}
        />
        <div ref={tableRef} className="d-none">
          <table>
            <thead>
              <tr>
                <th>S.N</th>
                <th>TASK DATE</th>
                <th>TASK TYPE</th>
                <th>EXAM NAME</th>
                <th>TASK TITLE</th>
                <th>TEACHER NAME</th>
                <th>EXPECTED START DATE</th>
                <th>ACTUAL START DATE</th>
                <th>EXPECTED DURATION</th>
                <th>AUDITOR COMMENT</th>
                <th>LINK / SCREENSHOT</th>
                <th>STATUS</th>
                <th>ACHIEVED DURATION</th>
                <th>ASSIGNED BY</th>
                <th>UPDATED AT</th>
              </tr>
            </thead>
            <tbody>
              {teacherTaskList?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{moment.utc(item.taskDate).format("LL")}</td>
                    <td>{item?.taskType}</td>
                    <td>{item?.examTypeId?.name}</td>
                    <td>{item?.taskTitle}</td>
                    <td>{item?.teacherId?.name}</td>
                    <td>{moment.utc(item.sessionStartTime).format("LL")}</td>
                    <td>{moment.utc(item.liveStartedAt).format("LL")}</td>

                    <td>{item?.taskDuration}</td>
                    <td>{item?.remarkDE}</td>
                    <td>
                      {item?.link ? item?.link : item?.file ? item?.file : "-"}
                    </td>
                    <td>
                      {item?.status === 1
                        ? "PENDING"
                        : item?.status === 2
                        ? "COMPLETE"
                        : item?.status === 3
                        ? "MISCELLANEOUS"
                        : item?.status === 1
                        ? "ON LEAVE"
                        : item?.status === 5
                        ? "NOT COMPLETED"
                        : "-"}
                    </td>
                    <td>
                      {item?.workDuration
                        ? getSeconds(item?.workDuration)
                        : null}
                    </td>
                    <td>
                      {item?.remarkBy ? item?.remarkBy : item?.teacherId?.name}
                    </td>
                    <td>
                      {moment.utc(item?.updatedAt).format("LL hh:mm:ss a")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <div className="contentBox">
      <PageTitle name={"TEACHER TASK PLAN"} isEditMode={isEditMode} />
      <div className="formDiv contentScrollbar">
        <div className="col-auto formWidth">{renderListMode()}</div>
      </div>
    </div>
  );
}

export default TeacherTaskPlan;
